import axios from './base'
const url = `/post`

// ================= 社区帖子管理（后端 PostService，tb_post / tb_post_comment，/post*） =================
// 产品规则：社区无审核无上下架，管理端只有删除；官方账号 = tb_user ID 1

// 帖子列表（无分页卡片流；筛选 keyword 标题/正文模糊 / type 1图文 2横版视频 3竖版视频；created_at 倒序）
// 列表项含 nickname / is_official（后端附带，user_id=0 固定官方昵称）
export function getPostList(params = {}) {
  return axios.request({
    url: `${url}`,
    method: "get",
    params,
  })
}

// 帖子详情（含留言 comments，按时间正序）
export function getPostDetail(id, params = {}) {
  return axios.request({
    url: `${url}/${id}`,
    method: "get",
    params,
  })
}

// 官方发帖（后端固定 user_id=0；type=1 传 images≤6，type≠1 传 video_url/cover/duration）
export function createPost(data = {}) {
  return axios.request({
    url: `${url}`,
    method: "post",
    data,
  })
}

// 官方回复留言（后端固定 user_id=0，并同步帖子 comment_count+1）
export function replyPost(id, data = {}) {
  return axios.request({
    url: `${url}/${id}/comment`,
    method: "post",
    data,
  })
}

// 删除帖子（软删，该帖留言一并删除，不可恢复）
export function deletePost(id, data = {}) {
  return axios.request({
    url: `${url}/${id}`,
    method: "delete",
    data,
  })
}

// 删除单条留言（软删，帖子 comment_count-1）
export function deletePostComment(commentId, data = {}) {
  return axios.request({
    url: `${url}/comment/${commentId}`,
    method: "delete",
    data,
  })
}
